import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { nanoid } from 'nanoid'

import ForgetVisa from 'shared/icons/forget_visa.svg'

import styles from './styles.module.scss'

export const UaeVisaAlert = () => {
  const { t } = useTranslation()

  const list = Object.values(
    t('purchase_page.uae.list', { returnObjects: true }),
  )
  return (
    <div className={styles.visa}>
      <div className={styles.header}>
        <h6 className={clsx(styles.title, 'bold-17')}>{t('notice')}</h6>
      </div>

      <div className={styles.visaBody}>
        <h6 className={clsx(styles.visaTitle, 'regular-16')}>
          <span>
            <img
              src={ForgetVisa}
              alt=""
              className={styles.forgetImage}
            />
          </span>

          {t('purchase_page.uae.dont_forget_visa')}
        </h6>

        <p className={clsx(styles.visaDescription, 'regular-14')}>
          {t('purchase_page.uae.visa_description')}
        </p>

        <ul className={styles.list}>
          {list.map((item) => (
            <li
              className={clsx(styles.item, 'regular-14')}
              key={nanoid()}
            >
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
